import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ThemeContextType {
  autumnMode: boolean;
  setAutumnMode: (value: boolean) => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const ThemeProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [autumnMode, setAutumnMode] = useState<boolean>(false);

  return (
    <ThemeContext.Provider value={{ autumnMode, setAutumnMode }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = (): ThemeContextType => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
